module.exports = __webpack_public_path__ + "img/icon-facebook.7f5839a0.svg";